/* Component Dependencies */
var photoViewerTemplate = require('templates/photoViewer.hbs');
var photoViewerReservationTemplate = require('templates/photoViewer-reservation.hbs');
var photoViewerHotelQuickViewTemplate = require('templates/photoViewer-hotelQuickView.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');
require('libs/gallery');

AriesComponent.create({
  type: 'photoViewer',
  options: {
    'categorySelector': '#view-category-trigger',
    'photoViewer':''
  },
  template: {
    'photoViewer': photoViewerTemplate,
    'photoViewer-reservation': photoViewerReservationTemplate,
    'photoViewer-hotelQuickView': photoViewerHotelQuickViewTemplate
  },
  events: {
    'click #view-category-trigger': 'toggleCategoryDropdown',
    'click #nav-list li > a': 'filterBySelectedCategory'
  },
  bindEvents: function ($) {
    var _self = this;

    if(_self.$el.find('.m-photo-gallery-slider ul').length) {
      _self.$el.find('#view-category-trigger').on('click', function(event) {
        _self.$el.find('#view-category-trigger span').toggleClass('up-arrow');
      });
      _self.$el.find('.m-photo-gallery').on('click', function(event) {
        if(!event.target.closest('.t-category-nav') && _self.$el.find('#nav-list').is(':visible')) {
          _self.$el.find('#view-category-trigger').trigger('click');
        }
      });
      _self.options.photoViewer = _self.$el.find('.m-photo-gallery-slider > ul').gallery({
        beforeChange: function(eventTarget, activeSlide) {
          if(_self.$el.find('iframe').length) {
            _self.$el.find('iframe').attr('src', '');
          }
          _self.loadImagesBeforeChange.call(_self, eventTarget, activeSlide);
        },
        afterChange: function(eventTarget, activeSlide) {
          if(activeSlide.find('iframe').length) {
            activeSlide.find('iframe').attr('src', activeSlide.find('iframe').attr('data-src'));
          }
        }
      }).data('plugin_gallery');
      _self.setCategoryDropdownPosition();
      _self.currentSlide = 1;
    } else {
      if(_self.$el.find('.mi-carousel').length) {
        _self.parentSelector = $('[data-component-id="' + _self.componentId + '"]');
        var dropdown = _self.parentSelector.find('.t-classic');
        var flag=false;
        var carousel = _self.parentSelector.find('.mi-carousel');
        var activeSlide;
        var categoryDropdown;

        if(_self.parentSelector.find('.slick-initialized').length) {
          _self.onSlickInit.call(_self);
        } else {
          carousel.on('init', function() {
            _self.onSlickInit.call(_self);
          });
        }

        carousel.on('beforeChange', function() {
          activeSlide = _self.parentSelector.find('.slick-current');
          if(activeSlide.find('iframe').length) {
            activeSlide.find('iframe').attr('src','');
          }
          _self.loadImagesBeforeChangeSlick.call(_self, arguments[2], arguments[3]);
        });
        carousel.on('afterChange', function() {    
          picturefill({reevaluate:true});     
          activeSlide = _self.parentSelector.find('.slick-current');
          if(activeSlide.find('iframe').length) {
            activeSlide.find('iframe').attr('src', activeSlide.find('iframe').attr('data-src'));
          }
        });

        dropdown.on('selectric-init', function() {
          _self.$el.find('#selectric-list0 li').attr('tabindex','1');
        });
        
        $(document).on('keydown', function(e) {
          if(e.keyCode === 9) {
            setTimeout(function() {
              if($(document.activeElement).closest('.selectric-wrapper').length) {
                _self.$el.find('.selectric-wrapper .label').css('font-weight', '600');
              } else {
                _self.$el.find('.selectric-wrapper .label').css('font-weight', '');
              }
            }, 1);
          }
        });

        categoryDropdown = _self.parentSelector.find('.selectric-items');

      //closing dropdown on outside click
        _self.parentSelector.not(categoryDropdown).on('click',function(e){
           selectric = _self.$el.find('.selectric-wrapper');
            if(selectric.hasClass('selectric-open')) {
              _self.$el.find('.selectric').click();
            }
        })
      //prevents popup to be closed on pressing key
        _self.parentSelector.find('.selectric-wrapper').on('keyup keypress keydown', function(e) {
            e.stopPropagation();          
        });

        
        dropdown.on('change', _self.navigateToNewCategory.bind(_self));
        _self.parentSelector.find('.mi-gallery .mi-carousel').on('beforeChange', _self.changePaginationOnSlideChange.bind(_self));

        setTimeout(function(){$(window).trigger('resize');},1);
      }
      _self.initialLoad = _self.$el.find('.mi-carousel').data('initialload');
    }   

  },
  /**
   * This method is executed when the carousel is initialized. It performs a couple of operations mentioned in the comments below.
   * @return {Boolean} Success/Failure
   */    
  onSlickInit: function _onSlickInit() {
    var _self = this;
    var slideToLoad;
				var miCarouselElement = _self.$el.find('.mi-carousel');
				var rightArrowElement;
				var leftArrowElement;
    var initialLoad = _self.$el.find('.mi-carousel').data('initialload');
    var totalImageCount = _self.$el.find('.t-classic').data('total-image-count');
    var dropdown = _self.parentSelector.find('.t-classic');

    //To focus image on initial load of gallery
    _self.$el.find('.slick-current').focus();

    //Loading the last 2 images of last category since the carousel is infinite
    for(var i=2; i<initialLoad; i++) {
      slideToLoad = _self.$el.find('div[data-slick-index="'+parseInt(totalImageCount - i)+'"] img');
      slideToLoad.attr('src') || slideToLoad.attr('src',slideToLoad.data('src'));
    }

				// Adding arrow data attribute and classes for tracking
				if(miCarouselElement && miCarouselElement.data('analytics-arrow')) {
					rightArrowElement = miCarouselElement.find(".slick-arrow.slick-next");
					leftArrowElement = miCarouselElement.find(".slick-arrow.slick-prev");

					rightArrowElement.addClass('analytics-click custom_click_track').attr('custom_click_track_value', 'HQV photogallery|right arrow|internal');
					leftArrowElement.addClass('analytics-click custom_click_track').attr('custom_click_track_value', 'HQV photogallery|left arrow|internal');
				}
  },
  /**
   * This method is executed when the selectric dropdown is changed. It is used to navigate to the new selected category. This calls the before-change function of Carousel as callback
   * @return {Boolean} Success/Failure
   */    
  navigateToNewCategory: function _navigateToNewCategory() {
    var selectDropdown = this.parentSelector.find('.t-classic');
    var startIndex = selectDropdown.find('option:nth-child(' + (selectDropdown[0].selectedIndex + 1) + ')').data('start-index');

    this.parentSelector.find('.mi-carousel').slick('slickGoTo', startIndex - 1);
  },
  /**
   * This method is executed whenever dropdown slide is changed. It shows/hides the title and caption accordingly
   * @return {Boolean} Success/Failure
   */   
  changePaginationOnSlideChange: function _changePaginationOnSlideChange(event, slick, currentSlide, nextSlide) {
    var currentImageWrapper = this.parentSelector.find('.slick-slide[data-slick-index='+ nextSlide +']');
    var captionContainer = this.parentSelector.find('.m-caption-container');
    var headerTitle = this.parentSelector.find('.m-gallery-heading');
    var currentImageNumber = this.parentSelector.find('.current-image-number');

    // Show title and caption if they are available, hide otherwise
    if(currentSlide !== nextSlide) {
      currentImageWrapper.attr('data-caption') ? captionContainer.show() : captionContainer.hide();
    }
    this.setPaginationContent(event, slick, currentSlide, nextSlide);

    if(this.parentSelector.hasClass('tile-hotel-quickview')) {
      currentImageNumber.html(nextSlide+1);
    }
  },
  /**
   * This method is executed initially and whenever the carousel state is changed. It is used to change the Pagination value using the start Index and total count
   * @return {Boolean} Success/Failure
   */   
  setPaginationContent: function _setPaginationContent(event, slick, currentSlide, nextSlide) {
    var paginationContainer;
    var selectDropdown = this.parentSelector.find('.t-classic');
    var currentImageWrapper = typeof nextSlide === "number" ? (this.parentSelector.find('.slick-slide[data-slick-index='+ nextSlide +']')) : (this.parentSelector.find('.slick-current'));
    var startIndex = parseInt(currentImageWrapper.data('slick-index')) + 1;
    var mediaCategoryDesc = currentImageWrapper.data('media-category-description');
    var totalSlides = this.parentSelector.find('.t-classic').data('total-image-count');
    var selectricWrapper = this.parentSelector.find('.selectric-wrapper');
    var selectricLabel = this.parentSelector.find('.selectric .label');
    var selectricButton = this.parentSelector.find('.selectric .button');
    var newWidth;
    var currentSelectedOption = this.parentSelector.find('.selected');

    $('.mi-gallery-info-button').removeAttr('title');

    // Updating the selected category in dropdown on slide change through arrow buttons
    if((typeof currentSelectedOption.data('index') === "number") && (currentSelectedOption.data('index') != currentImageWrapper.data('category-index'))) {
      this.parentSelector.find('#selectric-list0 li[data-index='+ (currentImageWrapper.data('category-index')) +']').trigger('click');
    }

    //updating the selectric label content on selecting an option from dropdown
    paginationContainer = this.parentSelector.find('.selectric .label');
    if(currentImageWrapper.data('video-link-text')) {
      paginationContainer.html("<span class='t-icon-video'></span>"+mediaCategoryDesc);
    } else {
      paginationContainer.text(mediaCategoryDesc + ' (' + startIndex + '/' + totalSlides + ')');
      if(currentSlide === nextSlide) {
        this.parentSelector.find('#selectric-opt00').text(selectDropdown.find('option:first-of-type').attr('data-media-category-description') + ' (' + selectDropdown.find('option:first-of-type').attr('data-media-count') + ')');
      }
    }

    // Width updated for selectric label if new width exceeds the previous width
    // 32px padding and 2px border included in newWidth
    newWidth = selectricLabel.outerWidth(true) + selectricButton.outerWidth(true) + 50;
    if(newWidth > selectricWrapper.width()+6) {
      // Additional 2px because selectricItems contains 2px border
      selectricWrapper.width(newWidth + 2);
      this.parentSelector.find('.selectric-items').width(newWidth);
    }
  },
  /**
   * This method is used to set category dropdown position 
   * based upon the hotel name visibility
  */
  setCategoryDropdownPosition: function() {
    var _self = this;
    var $categorySelector = _self.$el.find(_self.options.categorySelector);
    var $categoryList = _self.$el.find("#nav-list");
    var hotelNameDisplay = _self.$el.find('.t-hotel-name').is(':visible');
    var leftPosition = hotelNameDisplay ? $categorySelector.position().left - 44 : $categorySelector.position().left;
    
    $categoryList.css({
      top:  $categorySelector.position().top + 30,
      left: leftPosition
    });
  },
  /**
   * This method is used to toggle category dropdown
  */ 
  toggleCategoryDropdown: function(e) {
    if(e){
      e.preventDefault();
    }
    var _self = this;
    var $categoryList = _self.$el.find("#nav-list");
    $categoryList.slideToggle();
  },
  /**
   * This method is used to select category and filter gallery resuly based upon selected category
  */
  filterBySelectedCategory: function(e) {
    e.preventDefault();
    var _self = this;
    var categoryValue = $(e.currentTarget).attr('data-section');
    _self.toggleCategoryDropdown();
    if(categoryValue !== "" && typeof(categoryValue) !== "undefined") {
      _self.options.photoViewer.filterCategory(categoryValue);
    }
  },
  /**
  * This function is called on click of arrow buttons to load one more image (for reservation variation)
  * @param {e} : Event target - used to check whether slide change is triggered from category dropdown or arrow buttons
  * @param {activeSlide} : The new slide (<li>) on slide change
  */
  loadImagesBeforeChange: function(e, activeSlide) {
    var _self = this,
        i,
        slideToLoad,
        initialLoad = _self.$el.find('.m-photo-gallery-slider ul').data('initialload');

    if(e) {
      if(e.hasClass('next-btn')) {
        slideToLoad = _self.$el.find('li[data-index="'+parseInt(_self.currentSlide + initialLoad)+'"]');
        _self.currentSlide++;
      } else {
        slideToLoad = _self.$el.find('li[data-index="'+parseInt(_self.currentSlide - initialLoad)+'"]');
        _self.currentSlide--;
      }
      if(!slideToLoad.find('img').attr('src')) {
        slideToLoad.find('img').attr('src',slideToLoad.find('img').data('src'));
        slideToLoad.find('source').each(function() {
          $(this).attr('srcset',$(this).data('srcset'));
        });
      }
    } else {
      for(i=-(initialLoad - 1); i<=(initialLoad - 1); i++) {
        slideToLoad = _self.$el.find('li[data-index="'+ (parseInt(activeSlide.data('index')) + i) +'"]');
        if(i && !slideToLoad.find('img').attr('src')) {
          slideToLoad.find('img').attr('src',slideToLoad.find('img').data('src'));
          slideToLoad.find('source').each(function() {
            $(this).attr('srcset',$(this).data('srcset'));
          });
        }
      }
      _self.currentSlide = parseInt(activeSlide.data('index'));
    }
  },
  /**
  * This function is called on click of arrow buttons to load one more image (for hotel info variation)
  * @param {previousSlideIndex} : Index of the previous slide
  * @param {nextSlideIndex} : Index of the next slide
  */
  loadImagesBeforeChangeSlick: function(previousSlideIndex, nextSlideIndex) {
    var _self = this,
        slideToLoad = {},
        activeSlide = _self.$el.find('div[data-slick-index='+ nextSlideIndex +']');

    if(activeSlide.hasClass('category-start')) {
      _self.loadImagesOnSelectricChange.call(_self, activeSlide);
    } else {
      if(activeSlide.hasClass('video-slide')) {
        _self.loadImagesOnSelectricChange.call(_self, activeSlide);
      }

      if(previousSlideIndex - nextSlideIndex === -1 || previousSlideIndex - nextSlideIndex > 1) {
        slideToLoad = _self.$el.find('div[data-slick-index="'+parseInt(nextSlideIndex - 1 + _self.initialLoad)+'"]');
      } else if(previousSlideIndex - nextSlideIndex === 1 || previousSlideIndex - nextSlideIndex < -1) {
        slideToLoad = _self.$el.find('div[data-slick-index="'+parseInt(nextSlideIndex + 1 - _self.initialLoad)+'"]');
      }

      if(slideToLoad.length && !slideToLoad.find('img').attr('src')) {
        slideToLoad.find('img').attr('src',slideToLoad.find('img').data('src'));
        slideToLoad.find('source').each(function() {
          $(this).attr('srcset',$(this).data('srcset'));
        });
      }
    }
  },
  /**
  * This function is called on changing the category on selectric dropdown
  * @param {activeSlide} : The active slide after transition 
  */
  loadImagesOnSelectricChange: function(activeSlide) {
    var _self = this,
        i,
        slideToLoad;

    for(i=-(_self.initialLoad - 1); i<=(_self.initialLoad - 1); i++) {
      slideToLoad = _self.$el.find('div[data-slick-index="'+ (parseInt(activeSlide.data('slick-index')) + i) +'"]');
      if(i && slideToLoad.find('img').length && !slideToLoad.find('img').attr('src') ) {
        slideToLoad.find('img').attr('src',slideToLoad.find('img').data('src'));
        slideToLoad.find('source').each(function() {
          $(this).attr('srcset',$(this).data('srcset'));
        });
      }
    }
  }
});
